export default {
  ru: {
    placeholder: 'Поиск по тренировкам',
  },
  en: {
    // en
  },
};
